import { ElementBuilder } from "@universityofmaryland/web-builder-library";
function createElementWithRefs(props) {
  const { refs, element, children, elementStyles, attributes, className } = props;
  const builder = element ? new ElementBuilder(element) : new ElementBuilder();
  builder.withClassName(className);
  if (children) {
    builder.withChildren(...children);
  }
  if (elementStyles) {
    builder.withStyles(elementStyles);
  }
  if (attributes) {
    attributes.forEach((attr) => {
      const [key, value] = Object.entries(attr)[0];
      builder.withAttribute(key, value);
    });
  }
  const component = builder.build();
  return {
    element: component.element,
    className,
    styles: component.styles,
    refs
  };
}
export {
  createElementWithRefs
};
//# sourceMappingURL=_elementModel.js.map
